<div class="component">
  <span
    class="empty"
    [hidden]="!(emptyMessage | async)"
    [textContent]="emptyMessage | async"
  >
  </span>
  <div [hidden]="emptyMessage | async" class="tableWrapper">
    <ag-grid-angular
      class="ag-theme-cupcake reports-table"
      [gridOptions]="gridOptions"
      [enableServerSideSorting]="true"
      [suppressRowHoverHighlight]="true"
      [columnDefs]="columnDefs$ | async"
      [rowModelType]="'infinite'"
    ></ag-grid-angular>
  </div>
</div>
